@if (data?.reviewReport; as reviewReport) {
  <form [formGroup]="form">
    <div class="et-review-form-block mt-4">
      <div class="title4Font"
           i18n><span class="sc-red">A. </span>Recommendation @if (!data.isReadonly) {
          (Please check
          appropriate option)

        }
      </div>
      <div class="mt-4">
        <div class="mb-2">
          <p-radioButton inputId="etReviewRecommendationPublishAsIs"
                         name="recommendation"
                         [value]="reviewRecommendationEnum.PublishAsIs"
                         formControlName="recommendation">
          </p-radioButton>
          <label class="ml-2"
                 for="etReviewRecommendationPublishAsIs"
                 i18n>
            Publish as is
          </label>
        </div>
        <div class="mb-2">
          <p-radioButton inputId="etReviewRecommendationPublishAfterOptionalRevision"
                         name="recommendation"
                         [value]="reviewRecommendationEnum.PublishAfterOptionalRevision"
                         formControlName="recommendation">
          </p-radioButton>
          <label class="ml-2"
                 for="etReviewRecommendationPublishAfterOptionalRevision"
                 i18n>
            Publish after optional minor revision
          </label>
        </div>
        <div class="mb-2">
          <p-radioButton inputId="etReviewRecommendationPublishAfterMandatoryRevision"
                         name="recommendation"
                         [value]="reviewRecommendationEnum.PublishAfterMandatoryRevision"
                         formControlName="recommendation">
          </p-radioButton>
          <label class="ml-2"
                 for="etReviewRecommendationPublishAfterMandatoryRevision"
                 i18n>
            Publish after mandatory minor/major revision
          </label>
        </div>
        <div class="mb-2">
          <p-radioButton inputId="etReviewRecommendationReject"
                         name="recommendation"
                         [value]="reviewRecommendationEnum.Reject"
                         formControlName="recommendation">
          </p-radioButton>
          <label class="ml-2"
                 for="etReviewRecommendationReject"
                 i18n>
            Reject
          </label>
          @if (isRejected) {
            <span class="caption1Font"
                  i18n>
              <i class="fas fa-lg fa-exclamation-circle mr-2 sc-red"></i>Please enter a reason to C. Remarks (not
              mandatory)</span>
          }
        </div>
        @if (isRecommendationBlockInvalid) {
          <div class="relative">
            <div class="sc-validation-errors et-review-radio-block-validation-message p-0">
              <small class="p-error"
                     i18n>Please choose appropriate option for point "A. Recommendation"</small>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="et-review-form-block mt-4">
      <div class="title4Font mb-3"
           i18n><span class="sc-red">B. </span>Checklist</div>
      <et-review-report-checklist-item [index]="1"
                                       label="Is the manuscript of high scientific quality?"
                                       i18n-label
                                       itemControlName="highScientificQuality">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="2"
                                       label="Is the manuscript free from errors?"
                                       i18n-label
                                       itemControlName="freeFromErrors">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="3"
                                       label="Is the paper well organized?"
                                       i18n-label
                                       itemControlName="wellOrganized">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="4"
                                       label="Is the title appropriate?"
                                       i18n-label
                                       itemControlName="appropriateTitle">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="5"
                                       label="Are the references to related work adequate?"
                                       i18n-label
                                       itemControlName="adequateReferences">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="6"
                                       label="Is the English satisfactory?"
                                       i18n-label
                                       itemControlName="satisfactoryEnglish">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="7"
                                       label="Are the figures clear?"
                                       i18n-label
                                       itemControlName="clearFigures"
                                       [triState]="true">
      </et-review-report-checklist-item>
      <et-review-report-checklist-item [index]="8"
                                       label="Are the tables clear?"
                                       i18n-label
                                       itemControlName="clearTables"
                                       [triState]="true"
                                       [showDivider]="false">
      </et-review-report-checklist-item>
      <div class="relative mt-3">
        @if (isChecklistBlockInvalid) {
          <div class="sc-validation-errors et-review-radio-block-validation-message p-0">
            <small class="p-error"
                   i18n>Please fill out all points in "B. Checklist"</small>
          </div>
        }
      </div>
    </div>
    <div class="et-review-form-block mt-4 text-center">
      <div class="title4Font mb-3"
           i18n><span class="sc-red">C. </span>Remarks</div>
      @if (!data.isReadonly) {
        <span class="caption1Font"
              i18n>
          <i class="fas fa-lg fa-exclamation-circle mr-2 sc-red"></i>Please, summarize the reasons for your overall
          recommendation and
          provide us with helpful suggestions (especially regarding "No" answers on the Checklist) to improve the
          manuscript</span>
      }
      @if (hasRemarks) {
        <div class="field mt-5">
          <textarea scValidatable
                    pTextarea
                    pAutoResize
                    formControlName="remarks"
                    class="w-5"
                    placeholder="Enter remarks"
                    i18n-placeholder
                    [rows]="5"></textarea>
        </div>
      }
      @if (hasNoRemarks) {
        <div class="body2Font text-center"
             i18n>
          No Remarks
        </div>
      }
    </div>
    <div class="et-review-form-block mt-4">
      <div class="title4Font mb-3 text-center"
           i18n><span class="sc-red">D. </span>Attachment</div>
      @if (!data.isReadonly) {
        <div class="body2Font text-center"
             i18n>Additional comments can be uploaded here as Word or PDF</div>
        <sc-file-upload #fileUpload
                        class="w-5 mt-5 block sc-margin-auto"
                        name="attachment"
                        [uploadUrl]="data.attachmentUploadUrl"
                        [validationRules]="data.attachmentValidationRules$ | async"
                        (uploadStarted)="onUploadStarted()"
                        (uploadCompleted)="onUploadCompleted()">
        </sc-file-upload>
        <p-button label="Upload"
                  i18n-label
                  class="flex justify-content-center mt-3"
                  [loading]="fileUpload.requestInProcess$ | async"
                  [disabled]="!fileUpload.isValid()"
                  (onClick)="uploadDocument()">
        </p-button>
      }
      @if (data.isReadonly && !reviewReport.attachment) {
        <div class="body2Font text-center"
             i18n>
          No attachment
        </div>
      }
      @if (reviewReport.attachment) {
        <div class="sc-card flex justify-content-between align-items-center w-5 mt-5 p-3 sc-margin-auto">
          <sc-file-download [fileInfo]="reviewReport.attachment"
                            [download$]="data.downloadAttachment$">
          </sc-file-download>
          @if (!data.isReadonly) {
            <p-button icon="pi pi-times"
                      class="ml-3"
                      styleClass="p-button-rounded p-button-text sc-grey sc-small-icon-button"
                      (onClick)="deleteAttachment()"
                      [disabled]="deleteAttachmentInProcess">
            </p-button>
          }
        </div>
      }
    </div>
  </form>
}